import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  inject,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { ToolManager3DService } from '../../tools/tool-manager-3d.service';

@Component({
  selector: 'h3-secondary-toolbar-3d',
  templateUrl: './secondary-toolbar-3d.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SecondaryToolbar3DComponent
  extends DirectiveSuperclass
  implements AfterViewInit
{
  @ViewChild('insertionPoint', { read: ViewContainerRef })
  insertionPoint!: ViewContainerRef;
  private toolManager = inject(ToolManager3DService);

  ngAfterViewInit() {
    this.subscribeTo(this.toolManager.selectedActivatedTool$, (tool) => {
      this.insertionPoint.clear();
      if (!tool?.secondaryToolbarType) {
        return;
      }

      const componentRef = this.insertionPoint.createComponent(
        tool.secondaryToolbarType,
      );
      componentRef.instance.tool = tool;
      componentRef.changeDetectorRef.markForCheck();
    });
  }
}
